// ABOUTME: The text of the 5C guiding truth card: the storm's first truth tier, or the fixed No Storm line.
// ABOUTME: The short and child truth variants exist on the storm but are deliberately unused here.

import type { CrossingStormDto } from '../../../../types/api';
import { NO_STORM } from '../clouds/noStorm';

export const NO_STORM_TRUTH = 'Weather is not a Storm. Feelings can blow through and pass on their own. I can let them pass and keep steering.';
export const FALLBACK_STORM_NAME = 'THE STORM';

export function guidingTruthFor(storm: CrossingStormDto | undefined, stormCode: string | undefined): string {
  if (!storm || stormCode === NO_STORM) return NO_STORM_TRUTH;
  const tier = storm.truthTiers?.[0];
  return tier && tier.trim().length > 0 ? tier : NO_STORM_TRUTH;
}

export function stormNameFor(storm: CrossingStormDto | undefined, stormCode: string | undefined): string {
  return storm && stormCode !== NO_STORM ? storm.name.toUpperCase() : FALLBACK_STORM_NAME;
}
